/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Invitation
 */
export interface Invitation {
  /**
   *
   * @type {string}
   * @memberof Invitation
   */
  invitationToken?: string;
  /**
   *
   * @type {string}
   * @memberof Invitation
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof Invitation
   */
  emailAddress?: string;
  /**
   *
   * @type {string}
   * @memberof Invitation
   */
  name?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Invitation
   */
  expiresAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Invitation
   */
  invitationSentByUserId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Invitation
   */
  lastSentAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the Invitation interface.
 */
export function instanceOfInvitation(value: object): value is Invitation {
  return true;
}

export function InvitationFromJSON(json: any): Invitation {
  return InvitationFromJSONTyped(json, false);
}

export function InvitationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Invitation {
  if (json == null) {
    return json;
  }
  return {
    invitationToken:
      json["invitationToken"] == null ? undefined : json["invitationToken"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    emailAddress:
      json["emailAddress"] == null ? undefined : json["emailAddress"],
    name: json["name"] == null ? undefined : json["name"],
    expiresAt: json["expiresAt"] == null ? undefined : json["expiresAt"],
    invitationSentByUserId:
      json["invitationSentByUserId"] == null
        ? undefined
        : json["invitationSentByUserId"],
    lastSentAt: json["lastSentAt"] == null ? undefined : json["lastSentAt"],
  };
}

export function InvitationToJSON(json: any): Invitation {
  return InvitationToJSONTyped(json, false);
}

export function InvitationToJSONTyped(
  value?: Invitation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    invitationToken: value["invitationToken"],
    companyId: value["companyId"],
    emailAddress: value["emailAddress"],
    name: value["name"],
    expiresAt: value["expiresAt"],
    invitationSentByUserId: value["invitationSentByUserId"],
    lastSentAt: value["lastSentAt"],
  };
}
